import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ShoppingBag } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-brand-dark relative" data-id="element-53">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative bg-gradient-to-br from-brand-card to-brand-darker border-2 border-brand-gold/30 rounded-3xl p-8 sm:p-12 text-center shadow-2xl overflow-hidden" data-id="element-55">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMjEyLCAxNjIsIDc2LCAwLjEpIi8+PC9zdmc+')] opacity-50" data-id="element-56"></div>

          {/* Shopify Secure circular seal */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.6,
          rotate: -20
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6,
          type: 'spring'
        }} className="absolute top-4 right-4 sm:top-6 sm:right-6 w-24 h-24 sm:w-28 sm:h-28 z-20 pointer-events-none" aria-label="Sello: 100% Gestionado por Shopify Secure" data-id="element-57">
            {/* Rotating ring with circular text */}
            <motion.svg viewBox="0 0 120 120" className="absolute inset-0 w-full h-full" animate={{
            rotate: 360
          }} transition={{
            duration: 22,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-58">
              <defs data-id="element-59">
                <path id="seal-circle" d="M 60, 60 m -46, 0 a 46,46 0 1,1 92,0 a 46,46 0 1,1 -92,0" data-id="element-60" />
              </defs>
              <text fill="#D4A24C" style={{
              fontSize: '11px',
              letterSpacing: '2px',
              fontWeight: 700
            }} data-id="element-61">
                <textPath href="#seal-circle" startOffset="0" data-id="element-62">
                  100% GESTIONADO POR SHOPIFY SECURE ·
                </textPath>
              </text>
            </motion.svg>

            {/* Inner solid disc */}
            <div className="absolute inset-[18%] rounded-full bg-brand-gold flex items-center justify-center shadow-[0_0_20px_rgba(212,162,76,0.4)] border-2 border-brand-gold/60" data-id="element-63">
              <ShoppingBag className="w-6 h-6 sm:w-7 sm:h-7 text-brand-darker" strokeWidth={2.5} data-id="element-64" />
            </div>
          </motion.div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-65">
            <div className="w-24 h-24 bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 border border-brand-gold/20" data-id="element-66">
              <ShieldCheck className="w-12 h-12 text-brand-gold" data-id="element-67" />
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-68">
              Garantía de Hierro de 7 Días
            </h2>

            <p className="text-lg text-brand-text/90 leading-relaxed font-medium" data-id="element-69">
              Pruébalo por 7 días. Si no sientes que tu energía aumenta, si no
              ves resultados en tu confianza o si simplemente no te gusta el
              diseño, te devuelvo el 100% de tu dinero.
            </p>
            <p className="text-xl text-brand-gold font-bold mt-4 italic" data-id="element-70">
              Sin preguntas. El riesgo es todo mío.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}